import { render, staticRenderFns } from "./UwwsStudentBulkIcardPrint.vue?vue&type=template&id=1379781f&scoped=true&"
import script from "./UwwsStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
export * from "./UwwsStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./UwwsStudentBulkIcardPrint.vue?vue&type=style&index=0&id=1379781f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379781f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
